import React from 'react';
import RepProfileCoachingActivities from '$pages/$rep-profile/RepProfileCoachingActivities';
import {formatDuration} from 'utils/periodAsText';

export default class CoachReviewActivities extends React.Component {
  render() {
    const {RepProfilePageStore, UserStore} = this.props;
    const {
      coachingActivity,
      coachingTeamMetrics,
      didCoachingActivityFetchFail,
      didCoachingDonutFetchFail,
      didCoachingTeamMetricsFail,
      isCoachingActivityFetching,
      isCoachingTeamMetricsFetching,
    } = RepProfilePageStore;

    const repBeingViewed = UserStore.users.get(this.props.repId);
    const periodText = formatDuration(this.props.headerStartDate, this.props.headerEndDate, {
      shouldPluralize: false,
    });

    const reviewType = this.props.reviewType;

    return (
      <div className="tab-content">
        {didCoachingActivityFetchFail || didCoachingDonutFetchFail || didCoachingTeamMetricsFail ? (
          <p>There was a problem fetching the coaching activity.</p>
        ) : (
          <RepProfileCoachingActivities
            rep={repBeingViewed}
            coachingActivity={coachingActivity}
            coachingTeamMetrics={coachingTeamMetrics}
            isCoachingActivityLoading={isCoachingActivityFetching}
            isCoachingTeamMetricsLoading={isCoachingTeamMetricsFetching}
            reviewType={reviewType}
            onSelectRep={this.props.onSelectRep}
            periodText={periodText}
            startDate={this.props.startDate}
            endDate={this.props.endDate}
            location={this.props.location}
            renderTeamAverage={false}
          />
        )}
      </div>
    );
  }
}
